export default __webpack_public_path__ + "static/media/personalDetailshelpMobileHighlight.b68ff8ea.png";